import React, { useEffect, useState } from "react";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";
import { GetService } from "../../../Services/ConstantService";
import { API_URL } from "../../../Services/ApiService";
import BounceLoader from "react-spinners/BounceLoader";

export default function Questions() {
  let [loading, setLoading] = useState(true);
  const [QuestionList, setQuestionList] = useState([]);

  useEffect(() => {
    GetList();
  }, []);

  function GetList() {
    setLoading(true);
    GetService(API_URL.GET_QUESTIONS_LIST).then((res) => {
      console.log(res);
      if (res?.data?.status === true) {
        setQuestionList(res?.data?.data);
      }
      setLoading(false);
    });
  }

  return (
    <div className="Gallery-Wraps contact program">
      <main >
        <div style={{minHeight:'400px'}}>
        {!loading && (
        <>
        {/* blog-area-start */}
        <div
          className="tp-blog__area pb-30"
          // data-background="assets/img/breadcrumb/routing.png"
          style={{
            backgroundSize: "cover",
            backgroundImage: "url('assets/img/breadcrumb/routing.png')",
          }}
        >
          <div className="container text-center  ">
            <div className="row ">
              <div className="row text text-center pt-5 pb-15">
                <div className="col-xl-12 col-lg-12 col-md-12 text-center ">
                  <h4 className="text-left second">Questions</h4>
                </div>
              </div>
            </div>
            <div className="row text">
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="tp-service-details-wrapper">
                  <div className="class-heading">
                    <h4>Ordering</h4>
                  </div>
                  <div className="tp-service-details-faq">
                    <div className="tp-custom-accordion">
                      <div className="accordion" id="ordering">
                        {QuestionList &&
                          QuestionList?.Ordering?.map((list, i) => {
                            return (
                              <div key={i} className="accordion-items tp-faq-active">
                                <h2 className="accordion-header" id={`orderheading${i}`}>
                                  <button
                                    className="accordion-buttons collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#order${i}`} // Use a unique ID for each item
                                    aria-expanded="false"
                                    aria-controls={`order${i}`}
                                  >
                                    {list?.topquestion}
                                  </button>
                                </h2>
                                <div
                                  id={`order${i}`}
                                  className="accordion-collapse collapse"
                                  aria-labelledby={`orderheading${i}`}
                                  data-bs-parent="#ordering"
                                  style={{}}
                                >
                                  <div className="accordion-body">
                                  {list?.answer}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="tp-service-details-wrapper">
                  <div className="class-heading">
                    <h4>Image Preparation</h4>
                  </div>
                  <div className="tp-service-details-faq">
                    <div className="tp-custom-accordion">
                      <div className="accordion" id="image"> 
                      {QuestionList &&
                          QuestionList?.ImagePreparation?.map((list, i) => {
                            return ( 
                        <div className="accordion-items" key={i} >
                          <h2 className="accordion-header" id={`imgheading${i}`}>
                            <button
                              className="accordion-buttons collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#img${i}`}
                              aria-expanded="false"
                              aria-controls={`img${i}`}
                            >
                              {list?.topquestion}
                            </button>
                          </h2>
                          <div
                            id={`img${i}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`imgheading${i}`}
                            data-bs-parent="#image"
                            style={{}}
                          >
                            <div className="accordion-body">
                             {list?.answer}
                            </div>
                          </div>
                        </div> 
                         );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row text">
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="tp-service-details-wrapper">
                  <div className="class-heading">
                    <h4>Shipping</h4>
                  </div>
                  <div className="tp-service-details-faq">
                    <div className="tp-custom-accordion">
                      <div className="accordion" id="Shipping">
                        {QuestionList &&
                          QuestionList?.Shipping?.map((list, i) => {
                            return (
                              <div key={i} className="accordion-items tp-faq-active">
                                <h2 className="accordion-header" id={`Shippingheading${i}`}>
                                  <button
                                    className="accordion-buttons collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#Shipping${i}`} // Use a unique ID for each item
                                    aria-expanded="false"
                                    aria-controls={`Shipping${i}`}
                                  >
                                    {list?.topquestion}
                                  </button>
                                </h2>
                                <div
                                  id={`Shipping${i}`}
                                  className="accordion-collapse collapse"
                                  aria-labelledby={`Shippingheading${i}`}
                                  data-bs-parent="#Shipping"
                                  style={{}}
                                >
                                  <div className="accordion-body">
                                  {list?.answer}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <div className="tp-service-details-wrapper">
                  <div className="class-heading">
                    <h4>Policies</h4>
                  </div>
                  <div className="tp-service-details-faq">
                    <div className="tp-custom-accordion">
                      <div className="accordion" id="Policies"> 
                      {QuestionList &&
                          QuestionList?.Policies?.map((list, i) => {
                            return ( 
                        <div className="accordion-items" key={i} >
                          <h2 className="accordion-header" id={`Policiesheading${i}`}>
                            <button
                              className="accordion-buttons collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#Policies${i}`}
                              aria-expanded="false"
                              aria-controls={`Policies${i}`}
                            >
                              {list?.topquestion}
                            </button>
                          </h2>
                          <div
                            id={`Policies${i}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`Policiesheading${i}`}
                            data-bs-parent="#Policies"
                            style={{}}
                          >
                            <div className="accordion-body">
                             {list?.answer}
                            </div>
                          </div>
                        </div> 
                         );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* blog-area-end */}
        {/* blog-area-start */}
        <div
          className="tp-blog__area p-relative pb-20 pt-0"
          // data-background="assets/img/breadcrumb/routing.png"
          style={{
            backgroundSize: "cover",
            backgroundImage: "url('assets/img/breadcrumb/ .png')",
          }}
        >
          <div className="container text-center  ">
         
          </div>
        </div>
        {/* blog-area-end */}
        </>
        )}
        </div>
        <UpperFooterSlider />
      </main>

      {loading ? (
        <div className="LoaderSpinner">
          <BounceLoader
            color={"#607fe6"}
            loading={loading}
            speedMultiplier={2}
            size={50}
          />
          <div className="fw-semibold">Loading... Please wait.</div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
